import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../Api/Endpoints";

export const fetchGradeData = createAsyncThunk("api/grade", async () => {
  const token = localStorage.getItem("other");
  const response = await fetch(EndPoints.PRISM_GET_JOB_GRADE_LIST, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  return data;
});

const departmentSlice = createSlice({
  name: "grade",
  initialState: {
    gradedata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGradeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGradeData.fulfilled, (state, action) => {
        state.loading = false;
        state.gradedata = action.payload?.data || [];
      })
      .addCase(fetchGradeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default departmentSlice.reducer;